import Vue from "vue";

export async function auth({ commit, state }, payload) {
  const store = window.$store;
  const s = store.state;
  const mu = require('../mutations').default;
  const act = require('../actions').act;
  const { fb, fbBase, fbBaseUsers, fbusersbase } = require('../util').default.fb();
  const [t, f] = [true, false];

  const methods = {
    token: (payload) => {
      fb.auth()
        .signInWithCustomToken(payload.token)
        .then((d) => {
          window.localStorage.setItem("auth", JSON.stringify(d.user));
          return commit("setState", { prop: "auth", val: d.user });
        });
    },
    
    signinwithemaillink: () => {
      if (fb.auth().isSignInWithEmailLink(window.location.href)) {
        var email =
          window.localStorage.getItem("emailForSignIn") ||
          window.prompt("Please provide your email for confirmation");
        fb.auth()
          .signInWithEmailLink(email, window.location.href)
          .then((result) => {
            console.log("resulting user after magic button ", result.user);
            mu.setState(store.state, {
              prop: "auth",
              val: result.user,
            });
            window.localStorage.setItem("auth", JSON.stringify(result.user));
            act
              .auth(store.state, {
                type: "usercheck",
                email,
              })
              .then(() => {
                act.auth(store.state, {
                  type: "completesignup",
                  url: window.location.href,
                  email,
                });
                window.localStorage.removeItem("emailForSignIn");
                window.location.href = window.location.origin;
              });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    
    email: (payload) => {
      fb.auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then((data) => {
          if (data.user) {
            let globaluserdata = JSON.parse(JSON.stringify(data.user));
            fbBase
              .collection("user")
              .doc(data.user.uid)
              .get()
              .then((userData) => {
                var wb = fb.firestore().batch();
                if (userData.exists) {
                  var updateData = userData.data();

                  updateData.signin = updateData.signin || [];
                  updateData.signin.push(Date.now());
                  wb.set(
                    fbusersbase.collection(data.user.uid).doc("auth"),
                    globaluserdata,
                    { merge: t }
                  );
                  wb.set(
                    fbBaseUsers,
                    { [data.user.uid]: globaluserdata },
                    { merge: t }
                  );
                  wb.set(
                    fbusersbase.collection(data.user.uid).doc("apps"),
                    { [store.state.app.basics.database]: t },
                    { merge: t }
                  );
                  wb.set(
                    fbBase.collection("user").doc(data.user.uid),
                    updateData,
                    { merge: t }
                  )
                    .commit()
                    .then(async () => {
                      // Store full user object with emailVerified
                      const fullUser = JSON.parse(JSON.stringify(data.user));
                      window.localStorage.setItem(
                        "auth",
                        JSON.stringify(fullUser)
                      );
                      window.localStorage.setItem("email", payload.email);
                      
                      // Check if user is admin and ensure system users exist
                      if (store.state.app?.advanced?.roles?.admin?.members?.includes(data.user.uid)) {
                        await store.dispatch('ensureSystemUsers');
                      }
                      
                      return window.location.reload();
                    });
                } else {
                  var indexObj = {};
                  var timestamp = Date.now();
                  indexObj[data.user.uid] = timestamp;
                  var userContent = {
                    uid: data.user.uid,
                    id: data.user.uid,
                    name: "Glootie",
                    purpose: "",
                  };
                  wb.set(
                    fbusersbase.collection(data.user.uid).doc("auth"),
                    globaluserdata,
                    { merge: t }
                  );
                  wb.set(
                    fbusersbase.collection(data.user.uid).doc("apps"),
                    { [store.state.app.basics.database]: t },
                    { merge: t }
                  );
                  wb.set(
                    fbBase.collection("user").doc(data.user.uid),
                    userContent,
                    { merge: t }
                  )
                    .commit()
                    .then(() => {
                      // Store full user object with emailVerified
                      const fullUser = JSON.parse(JSON.stringify(data.user));
                      Vue.set(store.state, "auth", fullUser);
                      window.localStorage.setItem(
                        "auth",
                        JSON.stringify(fullUser)
                      );
                      window.localStorage.setItem("email", payload.email);
                      return window.location.reload();
                    });
                }
              });
          }
        })
        .catch(function (error) {
          var errorCode = error.code;
          var errorMessage = error.message;
          if (errorCode === "auth/wrong-password") {
            alert("Wrong password.");
          } else {
            alert(errorMessage);
          }
          console.log(error);
          document.getElementById("quickstart-sign-in").disabled = f;
        });
    },
    
    social: async (payload) => {
      var provider =
        payload.provider === "facebook"
          ? new fb.auth.FacebookAuthProvider()
          : payload.provider === "google"
          ? new fb.auth.GoogleAuthProvider()
          : console.error("Nothing to provide");
      fb.auth()
        .signInWithPopup(provider)
        .then(async (result) => {
          var user = JSON.parse(JSON.stringify(result.user));
          var userContent = {
            uid: user.uid,
            id: user.uid,
            name: user.displayName,
            provider: payload.provider,
          };
          var privateData = {
            email: user.email,
            signin: [Date.now()],
          };
          var wb = fb.firestore().batch();
          wb.set(fbusersbase.collection(user.uid).doc("auth"), user, {
            merge: t,
          });
          wb.set(fbBaseUsers, { [user.uid]: userContent }, { merge: t });
          wb.set(
            fbusersbase.collection(user.uid).doc("apps"),
            { [store.state.app.basics.database]: t },
            { merge: t }
          );
          wb.set(fbBase.collection("user").doc(user.uid), userContent, {
            merge: t,
          });
          wb.set(
            fbBase
              .collection("user")
              .doc(user.uid)
              .collection("private")
              .doc("content"),
            privateData,
            { merge: t }
          );
          return wb.commit().then(() => {
            // Store full user object with providerData for email verification check
            const fullUser = JSON.parse(JSON.stringify(result.user));
            window.localStorage.setItem("auth", JSON.stringify(fullUser));
            window.localStorage.setItem("email", user.email);
            mu.set(store.state, { key: "auth", val: fullUser });
            mu.set(store.state, {
              keys: ["componentKeys", "auth"],
              val: user.uid,
            });
            return window.location.reload();
          });
        })
        .catch(function (error) {
          var errorCode = error.code;
          var errorMessage = error.message;
          var email = error.email;
          var credential = error.credential;
          console.log(errorCode, errorMessage, email, credential);
        });
    },
    
    create: (payload) => {
      return fb
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then(async (data) => {
          let globaluserdata = JSON.parse(JSON.stringify(data.user));
          payload.type = "email";
          const id = data.user.uid;
          var userContent = {
            uid: id,
            id: id,
            name: "Anon " + Date.now(),
            purpose: "Undefined",
            required: payload.requirements,
          };
          var privateData = {
            email: data.user.email,
            signin: [Date.now()],
          };
          var wb = fb.firestore().batch();
          wb.set(fbusersbase.collection(id).doc("auth"), globaluserdata, {
            merge: t,
          });
          wb.set(
            fbusersbase.collection(data.user.uid).doc("apps"),
            { [store.state.app.basics.database]: t },
            { merge: t }
          );
          wb.set(fbBase.collection("user").doc(id), userContent);
          wb.set(
            fbBase
              .collection("user")
              .doc(id)
              .collection("private")
              .doc("content"),
            privateData
          );
          wb.commit().then(async () => {
            // Check if new user is admin and ensure system users exist
            if (store.state.app?.advanced?.roles?.admin?.members?.includes(id)) {
              await store.dispatch('ensureSystemUsers');
              
              // Create welcome message for new admin
              setTimeout(() => {
                store.dispatch('create', {
                  type: 'msg',
                  data: {
                    topic: 'Welcome',
                    users: [id, '7heXwzCbDQV0NX1IL9NRwyOCaNK2'],
                    type: 'welcome',
                    banter: {
                      [Date.now()]: {
                        text: 'Welcome to XMBL. You can build anything! go to /admin to do it yourself or try the agent at /terminal',
                        userId: '7heXwzCbDQV0NX1IL9NRwyOCaNK2'
                      }
                    },
                    created: Date.now()
                  }
                });
              }, 2000);
            }
          });

          act.auth(state, payload);
          return [userContent, privateData];
        })
        .catch(function (error) {
          var errorCode = error.code;
          var errorMessage = error.message;
          console.error(errorCode, errorMessage);
        });
    },
    
    reset: (payload) => {
      var resetCodeSettings = {
        url: window.location.origin + "/?email=" + payload.email,
        handleCodeInApp: t,
      };
      fb.auth()
        .sendPasswordResetEmail(payload.email, resetCodeSettings)
        .then(function () {
          console.alert("Password reset sent to email.");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    
    sendEmailVerification: async () => {
      const user = fb.auth().currentUser;
      if (!user) {
        console.error("No user logged in");
        return Promise.reject(new Error("No user logged in"));
      }
      
      // Reload user to ensure we have the latest email from Firebase Auth
      await user.reload();
      
      if (!user.email) {
        console.error("User has no email address");
        return Promise.reject(new Error("User has no email address"));
      }
      if (user.emailVerified) {
        console.log("Email already verified");
        return Promise.resolve({ message: "Email already verified" });
      }
      
      const store = window.$store;
      console.log("Sending verification email to Firebase Auth email:", user.email);
      console.log("Store auth email:", store.state.auth.email);
      
      // Firebase's sendEmailVerification - this should work if Firebase is properly configured
      var actionCodeSettings = {
        url: window.location.origin,
        handleCodeInApp: false, // Use email link, not in-app handling
      };
      
      try {
        await user.sendEmailVerification(actionCodeSettings);
        console.log("✓ Firebase verification email sent successfully to:", user.email);
        console.log("Note: Check your spam folder if you don't see it in your inbox");
        return { message: "Verification email sent. Please check your inbox (and spam folder)." };
      } catch (firebaseError) {
        console.error("✗ Firebase email verification failed:", firebaseError);
        console.error("Error code:", firebaseError.code);
        console.error("Error message:", firebaseError.message);
        
        // If Firebase fails, we can't generate a verification link from client-side
        // So we'll just inform the user and suggest they check Firebase configuration
        const errorMsg = firebaseError.message || "Unknown error";
        return Promise.reject(new Error(`Failed to send verification email: ${errorMsg}. Please check Firebase email configuration or contact support.`));
      }
    },
    
    magiclink: (payload) => {
      var actionCodeSettings = {
        url: window.location.origin,
        handleCodeInApp: t,
      };
      fb.auth()
        .sendSignInLinkToEmail(payload.email, actionCodeSettings)
        .then(function () {
          localStorage.setItem("emailForSignIn", payload.email);
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    
    completesignup: (payload) => {
      if (store.state.userExists) {
        alert("User exists. Reset password instead.");
      } else {
        var pass = prompt("Cheers. Please choose a password.");
        var newPass = prompt("Once more...");
        if (newPass !== pass) {
          act.auth(state, payload);
        } else {
          act.auth(state, { type: "changepass", pass });
        }
      }
    },
    
    changepass: (payload) => {
      var user = fb.auth().currentuser;
      user.updatePassword(payload.pass);
    },
    
    logout: () => {
      fb.auth().signOut();
      state.auth = {};
      localStorage.clear();
      if (caches) {
        caches.keys().then((keys) => {
          if (keys.length > 0) {
            keys.forEach((key, keyIndex) => {
              caches.delete(key);
              if (keyIndex === keys.length - 1) {
                window.location.reload();
              }
            });
          } else {
            window.location.reload();
          }
        });
      } else {
        window.location.reload();
      }
    },
    
    usercheck: (payload) => {
      if (!payload.email) return f;
      store.state.isEmail = t;
      return fb
        .auth()
        .fetchSignInMethodsForEmail(payload.email)
        .then(function (result) {
          if (result[0]) {
            store.state.userExists = t;
          } else {
            return f;
          }
          return store.state.userExists;
        });
    },
    
    currentuser: () => {
      var currentuser = fb.auth().currentUser;
      if (
        store.state.user[currentuser.uid] ||
        store.state.users[currentuser.uid]
      ) {
        return currentuser.uid;
      } else {
        return currentuser.uid
          ? fbBase
              .collection("user")
              .doc(currentuser.uid)
              .get()
              .then((userData) => {
                return userData.exists
                  ? currentuser.uid
                  : act.auth(s, { type: "logout" });
              })
          : f;
      }
    }
  };

  if (store.state.debug) mu.log("auth", payload);
  
  return methods[payload.type]
    ? methods[payload.type](payload)
    : (alert("Incomplete authorization"), console.error("Incomplete authorization", payload));
}

